import { render, staticRenderFns } from "./Recommendation.Video.vue?vue&type=template&id=0a33a170&scoped=true&"
import script from "./Recommendation.Video.vue?vue&type=script&lang=js&"
export * from "./Recommendation.Video.vue?vue&type=script&lang=js&"
import style0 from "./Recommendation.Video.vue?vue&type=style&index=0&id=0a33a170&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33a170",
  null
  
)

export default component.exports